// Config.
import AppConfig	from '../config/config.js';

/**
 * <pre>
 * UgcWall utility methods.
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:UgcWall.Util
 * @namespace
 */
const Config = {

	/**
	 * Utility method to return app config specific to module type (social wall/entries).
	 *
	 */
	getConfigForModuleType: function(moduleType) {

		let moduleConfig;
		let moduleTypeKey = moduleType.toLowerCase();

		if(AppConfig[moduleTypeKey]) {
			moduleConfig = AppConfig[moduleTypeKey];
		}

		return moduleConfig;
	},

	/**
	 * Utility method to return stateKey from app config specific to module type (social wall/entries).
	 *
	 */
	getStateKeyForModuleType: function(moduleType) {

		let stateKey;
		let moduleTypeConfig = Config.getConfigForModuleType(moduleType);

		if(moduleTypeConfig.stateKey) {
			stateKey = moduleTypeConfig.stateKey;
		}

		return stateKey;
	}
}

export default Config;